import svgMaskMirror from '@img/masks/mirror-inner.svg';
import svgMaskMirrorPortrait from '@img/masks/mirror-portrait-inner.svg';
import svgMaskCurtains from '@img/masks/curtains-inner.svg';
import svgMaskFrame from '@img/masks/frame-inner.svg';
import * as React from 'react';
import S from './ImageMask.styles';
const ImageMask = ({ children, mask }) => {
    if (!mask) {
        return React.createElement(React.Fragment, null, children);
    }
    const maskStyles = { '--mask': `url('${getMaskUrl(mask)}')` };
    return React.createElement(S.Container, { style: maskStyles }, children);
    function getMaskUrl(mask) {
        switch (mask) {
            case 'mirror':
                return svgMaskMirror;
            case 'mirror-portrait':
                return svgMaskMirrorPortrait;
            case 'curtains':
                return svgMaskCurtains;
            case 'frame':
                return svgMaskFrame;
            default:
                return '';
        }
    }
};
export default ImageMask;
